export function getDisplayName(args) {
  return {
    type: 'inspect_styles',
    selector: args.selector
  };
}
